var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "leasingSearchOptionBlock",
      class: { "leasingSearchOptionBlock--open": _vm.open },
    },
    [
      _c(
        "button",
        {
          staticClass: "leasingSearchOptionBlock__header",
          attrs: { type: "button" },
          on: { click: _vm.handleClick },
        },
        [
          _c("span", { staticClass: "leasingSearchOptionBlock__title" }, [
            _vm._v("\n                " + _vm._s(_vm.title) + "\n            "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "leasingSearchOptionBlock__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 448 512",
                  fill: "currentColor",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z",
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "leasingSearchOptionBlock__body" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }